import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseText, BaseView } from '@/components/base'

export const EmptyNotifications: React.FC = () => {
  const { t } = useTranslation()

  return (
    <BaseView
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minHeight: 'calc(100vh - 120px)', // Учитываем высоту header
        paddingBottom: '120px',
        position: 'relative',
        zIndex: 2,
      }}
    >
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.default"
        textAlign="center"
      >
        {t('translation:emptyNotifications')}
      </BaseText>
    </BaseView>
  )
}
